import React from 'react';
import PropTypes from 'prop-types';
import { getNodes } from '../utils/contentful';
import Page from '../components/Page';

PageTemplate.propTypes = {
  data: PropTypes.shape({
    pages: PropTypes.shape({}).isRequired,
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default function PageTemplate({ data: { pages }, location }) {
  return (
    <Page
      title="404 Not Found"
      pages={getNodes(pages)}
      location={location}
    >
      <article>
        Unfortunately, the page you are looking for does not exist.
      </article>
    </Page>
  );
}

export const pageQuery = graphql`
  query NotFoundQuery {
    pages: allContentfulPage(limit: 1000) {
      edges {
        node {
          id
          slug
          title
          subpages {
            id
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/404.js